import moment from "moment";

export const formatFollowUpDates = (date) => (date ? moment(date).utc().format("YYYY-MM-DD HH:mm:00") : null);
